module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/wallet-2-c3701558805f12d6607399a9a420933f.svg";